import {Typeahead} from 'react-bootstrap-typeahead'
import {Modal, Grid, Col, Row} from 'react-bootstrap'
import {t} from '../../helpers/translate'
import React from 'react'
import {getTrackingCode, getUserCode} from '../../helpers/access'

class SchoolSelectionComponent extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      currentSchool: '',
      saleChannels: this.getModalSchoolOptions(),
    };
    this.openForm = this.openForm.bind(this);
  }

  openForm(event) {
    if (!this.state.currentSchool) {
      return;
    }
    const baseUrl = this.props.baseUrl;
    const halfUrl = `${baseUrl}${baseUrl.includes('?') ? '&' : '?'}${this.getTrackingCode()}${getUserCode(this.props.paymentType)}`;
    window.open(halfUrl);
    this.setState({currentSchool: ''})
    this.props.hideModal();
  }

  getTrackingCode() {
    return `tracking_code=${this.state.currentSchool}`;
  }

  getModalSchoolOptions(){
  	const schools = [];
  	const schoolList = sessionStorage.getItem('all_schools');
  	
  	schoolList && schoolList.split(",").forEach(function(item, index) {
  		schools.push({'key': item, 'value': item});
  	});
  	
  	return schools;
  }

  render() {
    return <Modal id='salesChannelModal' bsSize='small' show={this.props.showModal} onHide={this.props.hideModal} backdrop='static'>
      <Modal.Header>
        <Modal.Title>{t('Select School')}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Grid>
          <Row className='show-grid'>
            <Col lg={1}>{t('School')}</Col>
            <Col lg={2}>
              <Typeahead
                bsSize='sm'
                className='salesChannelList'
                filterBy={(option, text) => option}
                labelKey={saleChannel => `${saleChannel.key}`}
                onChange={(selected) => this.setState({currentSchool: selected[0].value})}
                options={this.state.saleChannels}
                placeholder={t('Required')}
              />
            </Col>
          </Row>
        </Grid>
      </Modal.Body>

      <Modal.Footer>
        <button className="btn button-primary" onClick={this.props.hideModal}>{t('Cancel')}</button>
        <button className="btn button-secondary" onClick={this.openForm}>{t('Proceed')}</button>
      </Modal.Footer>

    </Modal>;
  }
}

SchoolSelectionComponent.displayName = 'SchoolSelectionComponent';
export default SchoolSelectionComponent;



// WEBPACK FOOTER //
// ./src/components/common/SchoolSelectionComponent.js